import { useRef } from 'react';
import { useBinnaclesStore } from '@stores/binnacles';
import { useCommentValidation } from '@contexts/comment-validation-context';
import { GetUser } from "@metronic/_helpers";
import { EVENT_STAGES } from '@constants/case-statuses';
import { getBySlug } from '@services/hospitalization';

export const useAutomaticCommentSave = ({ 
  caseData, 
  eventStage = null,
  isPageable = false,
  comment = "",
  hideReason = true 
}) => {
  const { store: storeBinnacle } = useBinnaclesStore();
  const { markAsCommented } = useCommentValidation();
  const { user: userAuth } = GetUser();
  const triggerRef = useRef(null);

  const saveCommentAutomatically = async () => {
    try {
      const autoEventStage = eventStage || EVENT_STAGES[caseData?.caseStatusId];
      
      const values = {
        comment: comment || "",
        userId: userAuth.idUser,
        event: autoEventStage,
        reason: hideReason ? "" : ""
      };

      let caseType;
      if (!hideReason) {
        caseType = "Cancelado";
      } else {
        caseType = caseData?.caseType || autoEventStage;
      }

      const dataBinnacle = {
        ...values,
        caseType: caseType,
        axaCategories: caseData?.axaCategories,
        movementsMedicalOpinion: caseData?.movementsMedicalOpinion,
        complexCase: caseData?.complexCase,
      };

      await storeBinnacle(dataBinnacle, caseData.id, caseData.slug, isPageable);
      markAsCommented();
      
      return true;
    } catch (error) {
      console.error('Error saving automatic comment:', error);
      return false;
    }
  };

  const saveCommentAutomaticallyUnam = async () => {
    const { data: currDataCase } = await getBySlug(caseData.slug);
    if (currDataCase.policyType === 'UNAM') {
      await saveCommentAutomatically();
    }
  };

  const saveCommentIfValid = async () => {
    if (!caseData?.id) {
      console.warn('No case data available for automatic comment save');
      return false;
    }
    
    return await saveCommentAutomatically();
  };

  return {
    saveCommentAutomatically: saveCommentIfValid,
    saveCommentAutomaticallyUnam: saveCommentAutomaticallyUnam,
    setTriggerRef: (ref) => { triggerRef.current = ref; }
  };
}; 